import { createContext } from "react";
import { PaywallContextData } from "./types";

export const PaywallContext = createContext({} as PaywallContextData);
